import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle the subscription logic
    // For demo purposes, just showing success message
    setSubmitted(true);
  };
  
  return (
    <section className="newsletter">
      <div className="container">
        <div className="newsletter-content">
          <h2>Subscribe to Our Newsletter</h2>
          <p>Get the latest recipes and cooking tips delivered straight to your inbox.</p>
          
          {submitted ? (
            <div className="success-message">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <p>Thank you for subscribing!</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="newsletter-form">
              <input 
                type="email" 
                placeholder="Your email address" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="btn">Subscribe</button>
            </form>
          )}
        </div>
      </div>
      
      <style jsx>{`
        .newsletter {
          background-color: var(--light-color);
          padding: 4rem 0;
        }
        
        .newsletter-content {
          text-align: center;
          max-width: 600px;
          margin: 0 auto;
        }
        
        .newsletter h2 {
          margin-bottom: 1rem;
        }
        
        .newsletter p {
          margin-bottom: 2rem;
          color: var(--gray);
        }
        
        .newsletter-form {
          display: flex;
          max-width: 500px;
          margin: 0 auto;
        }
        
        .newsletter-form input {
          flex: 1;
          padding: 0.8rem 1.2rem;
          border: 1px solid #ddd;
          border-radius: 4px 0 0 4px;
          font-size: 1rem;
        }
        
        .newsletter-form .btn {
          border-radius: 0 4px 4px 0;
        }
        
        .success-message {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #2ecc71;
        }
        
        .success-message svg {
          margin-right: 10px;
        }
        
        @media (max-width: 576px) {
          .newsletter-form {
            flex-direction: column;
          }
          
          .newsletter-form input {
            border-radius: 4px;
            margin-bottom: 1rem;
          }
          
          .newsletter-form .btn {
            border-radius: 4px;
          }
        }
      `}</style>
    </section>
  );
};

export default Newsletter;